import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Jan",
    uv: 4000,
    pv: 240,
    amt: 2400,
  },
  {
    name: "Feb",
    uv: 3000,
    pv: 139,
    amt: 2210,
  },
  {
    name: "March",
    uv: 2000,
    pv: 980,
    amt: 2290,
  },
  {
    name: "April",
    uv: 2780,
    pv: 390,
    amt: 2000,
  },
  {
    name: "May",
    uv: 1890,
    pv: 480,
    amt: 2181,
  },
  {
    name: "Jun",
    uv: 2390,
    pv: 380,
    amt: 2500,
  },
  {
    name: "July",
    uv: 3490,
    pv: 430,
    amt: 2100,
  },
];

export default class Barchart1 extends PureComponent {
  render() {
    return (
      <ResponsiveContainer height={200}>
        <BarChart
          maxWidth={{ xs: 250, sm: 300, md: 450 }}
          height={200}
          data={data}
          margin={{
            top: 5,
            right: 5,
            left: 5,
            bottom: 5,
          }}
          barSize={20}
        >
          <XAxis
            dataKey="name"
            // scale="point"
            padding={{ left: 10, right: 10 }}
          />
          <YAxis type="number" domain={[0, 5000]} />
          <Tooltip />
          <Legend />
          <CartesianGrid strokeDasharray="3 3" />
          <Bar 
          // dataKey="uv"
          dataKey="Year-2022"
           fill="#26ACF8" background={{ fill: "#eee" }} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
